// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3a0I6","inputWrap":"Table_inputWrap__3dxHl","col":"Table_col__1MJ-O","bmiTooltip":"Table_bmiTooltip__CxA6P"};